import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
import { FadeUp } from '../ui/FadeUp';
export function HeroSection() {
  return <SectionWrapper bgColor="ivory" id="hero" className="min-h-[100svh] flex flex-col justify-center !py-20 relative overflow-hidden" data-id="element-75">
      {/* Gradient fade at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-b from-transparent to-sand pointer-events-none" data-id="element-76" />

      <div className="relative z-10" data-id="element-77">
        <FadeUp delay={0} data-id="element-78">
          <div className="inline-flex items-center gap-2 bg-plum text-white text-[10px] tracking-[0.15em] uppercase px-3.5 py-1.5 rounded-full mb-4 font-medium" data-id="element-79">
            <span className="text-[7px] opacity-70" data-id="element-80">◆</span>
            Sistema ProMind Energy™
          </div>
        </FadeUp>

        <FadeUp delay={0.1} data-id="element-81">
          <h1 className="text-[clamp(42px,11vw,64px)] text-charcoal mb-6 tracking-[-0.01em] leading-[1.1]" data-id="element-82">
            ¿Estás eligiendo cómo te sentís…
            <br data-id="element-83" />
            o está decidiendo
            <br data-id="element-84" />
            <em className="italic text-plum" data-id="element-85">tu entorno por vos?</em>
          </h1>
        </FadeUp>

        {/* Hero image */}
        <FadeUp delay={0.2} data-id="element-86">
          <div className="mx-[-24px] mt-7 mb-0 relative" data-id="element-87">
            <img src="https://cdn.magicpatterns.com/uploads/w9shxTz4XCyB6HAQxF5bhK/mujer_pensativa.jpg_2.webp" alt="Mujer adulta en momento de reflexión" width={800} height={520} loading="eager" className="w-full h-auto object-contain block" style={{
            filter: 'sepia(15%) contrast(0.95)'
          }} data-id="element-88" />
          </div>
        </FadeUp>

        <FadeUp delay={0.3} data-id="element-89">
          <div className="w-10 h-[1px] bg-border-custom mt-7 mb-6" data-id="element-90" />
        </FadeUp>

        <FadeUp delay={0.35} data-id="element-91">
          <p className="text-[15px] text-muted leading-[1.7] mb-2" data-id="element-92">
            No es falta de{' '}
            <strong className="text-plum font-medium" data-id="element-93">actitud</strong>. Es falta
            de <strong className="text-plum font-medium" data-id="element-94">regulación</strong>.
          </p>
        </FadeUp>

        <FadeUp delay={0.45} data-id="element-95">
          <p className="text-[13px] text-muted mb-8 tracking-[0.01em]" data-id="element-96">
            Descubrí el{' '}
            <span className="font-serif italic text-[15px] text-plum" data-id="element-97">
              Sistema ProMind Energy™
            </span>{' '}
            — un sistema estructurado de Regulación Energética Cotidiana en 3
            fases.
          </p>
        </FadeUp>

        <FadeUp delay={0.55} data-id="element-98">
          <CTAButton data-id="element-99">Quiero recuperar mi eje</CTAButton>
        </FadeUp>
      </div>
    </SectionWrapper>;
}